module.exports = __webpack_public_path__ + "static/media/home-stock-04.6a29ebb2.png";